export default __webpack_public_path__ + "static/media/galaxy.ef4e164b.jpg";